import React from "react"
import { ReglaCard, ReglaCardProps } from "./ReglaCard"
import { RestoCard } from "./RestoCard"

export const TipoPanel: React.FC<{
  tipo: number
  reglas: ReglaCardProps[]
}> = ({ tipo, reglas }) => {
  const sorted = React.useMemo(
    () =>
      [...reglas].sort(
        (a, b) => (a.rango?.valorInferior ?? 0) - (b.rango?.valorInferior ?? 0)
      ),
    [reglas]
  )
  return (
    <div className='tw-space-y-3 tw-max-w-screen-md tw-w-full'>
      {sorted.map((r) => (
        <ReglaCard
          id={r.id}
          key={r.id}
          tipo={tipo}
          regla={r}
        />
      ))}
      <RestoCard />
    </div>
  )
}
